import { pathToRegexp } from 'path-to-regexp';
import QueryString from 'query-string';

import convertParams from './params';

export default class Route {
  constructor(path, type) {
    if (typeof path === 'string') {
      this.path = path;
      this.component = false;
      this.requiresTOC = false;
      this.requiresTransferPassword = false;
      this.updateTransfer = false;
    } else {
      this.path = path.route;
      this.component = path.component;
      this.requiredAuthState = path.requiredAuthState;
      this.name = path.name;
      this.title = path.title;
      this.requiresTOC = !!path.requiresTOC;
      this.requiresTransferPassword = !!path.requiresTransferPassword;
      this.updateTransfer = !!path.updateTransfer;
      this.payment = path.payment;
      this.shouldRedirect = path.shouldRedirect;
      this.redirectTo = path.redirectTo;
    }

    this.keys = [];
    this.type = type;
    this.regexp = pathToRegexp(this.path, this.keys);
  }

  matches(path, origin = location) {
    const match = this.regexp.exec(path);
    if (!match) {
      return false;
    }
    const hash = origin.hash || '';

    return {
      requiredAuthState: this.requiredAuthState,
      component: this.component,
      params: convertParams(match, this.keys),
      segment: hash.replace(/^#/, ''),
      query: QueryString.parse(origin.search),
      context: false,
      type: this.type,
      name: this.name,
      title: this.title,
      path,
      requiresTOC: !!this.requiresTOC,
      requiresTransferPassword: !!this.requiresTransferPassword,
      updateTransfer: !!this.updateTransfer,
      payment: this.payment,
      shouldRedirect: this.shouldRedirect,
      redirectTo: this.redirectTo,
    };
  }
}
